import React from 'react';
import styled from 'styled-components';
import { Check } from '@alefeducation/ui-elements-library-icons';

export interface InfoTuplePropsType {
  label: string;
  value: React.ReactNode;
}
export interface StatusInfoPropsType {
  status: string;
}

export const InfoTuple = (props: InfoTuplePropsType) => {
  const { label, value } = props;
  return (
    <InfoTupleItem>
      <Label>{label}</Label>
      <Value>{value}</Value>
    </InfoTupleItem>
  );
};

export const HorizontalBreaker = () => (
  <HorizontalBreakerItem></HorizontalBreakerItem>
);

export const StatusInfo = (props: StatusInfoPropsType) => {
  const { status } = props;

  let statusIcon;
  if (status === 'COMPLETED') {
    statusIcon = <Check width={12} height={12} color="#70bf42" />;
  } else if (
    status === 'PENDING' ||
    status === 'IN QUEUE' ||
    status === 'STARTED'
  ) {
    statusIcon = <GreenBigDot />;
  } else {
    statusIcon = <RedBigDot />;
  }

  return (
    <StatusInfoCell>
      {statusIcon}
      <StatusInfoCellLabel>{status}</StatusInfoCellLabel>
    </StatusInfoCell>
  );
};

export const StatusInfoCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const StatusInfoCellLabel = styled.span`
  text-transform: lowercase;
  &::first-letter {
    text-transform: uppercase;
  }
`;

export const GreenBigDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #70bf42;
`;

export const RedBigDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #ff6d6d;
`;

const InfoTupleItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Label = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
`;
const Value = styled.div`
  font-size: 14px;
  font-weight: 300;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
`;

const HorizontalBreakerItem = styled.div`
  border: 1px solid #dadde0;
  width: 1px;
`;
